import React from "react";
import Card from "react-bootstrap/Card";

import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

function AboutCard() {

  const navigate = useNavigate(); // Initialize navigate
  
    const handleClick = () => {
      navigate("/story"); // This will navigate to the "/another-page" route
    };
  
  
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p className="about-text">
            At Choicest Fruit®, our vision is to <span className="purple">empower young people, underserved populations and seniors</span> in Hays, Travis, Williamson and Caldwell Counties, Texas,
            to become active participants in the development of technology that promotes positive relationships
            with themselves, others, and the world. We aim to equip individuals with the awareness, values,
            and skills needed to contribute to just and thriving societies through responsible tech practices.
            By integrating local experiences and diverse perspectives into the tech development process,
            we ensure that technology is designed, distributed, and used in ways that reflect the unique needs and values of our communities.
          </p>

          <p className="about-text">
            The name Choicest Fruit® symbolizes the idea that, just as the best fruit comes from the healthiest tree, the most valuable technologies and innovations
            are the result of <span className="purple">nurturing knowledge</span> and <span className="purple">thoughtful choices</span>.  It reflects how technology, much like fruit, is the result of scientific growth
            and the choices we make in shaping our future.  Inspired by the belief that the most important technological
            advances are those that serve humanity’s welfare, our name reflects our commitment to cultivating and sharing the ’choicest fruits’—skills,
            opportunities, and innovations that empower individuals and communities to thrive in a tech-driven world.
          </p>

          <p className="about-text">
            Our mission goes beyond providing <span className="purple">access to knowledge</span>; we aim to create an environment where everyone can actively engage in technology
            development, making it meaningful and impactful. We believe that conversations about the ethical use and development of technology
            should start early, fostering curiosity, creativity, and critical thinking in young people. Whether a person’s interest in technology
            arises naturally or through exposure, we tailor our approach to their unique developmental paths and aspirations, ensuring that our
            training programs resonate with each individual’s journey.
          </p>

          <p className="about-text">
            A core principle of Choicest Fruit® is infusing <span className="purple">human values</span> into the tech development process.
            We teach young people to consider the broader impacts of technology at every stage,
            encouraging them to move beyond simply replicating market-driven trends. By emphasizing
            their agency in creating grassroots tech solutions, we help them develop the skills to
            create technology that meets the needs of their families, peers, and local communities.
          </p>         

          <p style={{ color: "rgb(4,99,112)" }}>
            “… In this day the choicest fruit of the tree of knowledge is that which serveth the welfare of humanity and safeguardeth its interests.“
          </p>
          <Button onClick={handleClick}     
      >Our Story</Button>
          
          {/* <footer className="blockquote-footer"></footer> */}
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
